import React, { useState , useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader, Label, Input} from 'reactstrap';
import { Update_Bot_Thread } from '../../../slices/thunks';


const Edit_Thread_Name_Modal = ({  thread_id, thread_title , assistant_id , Bot_ID } ) => {
    const [modal_center, setmodal_center] = useState(false);
    const [thread_title_value, setthread_title_value] = useState(thread_title)


    useEffect(() => {
        setthread_title_value(thread_title)
    }, [thread_title])
    
    // const {loading } = useSelector((state)=> state.Thread)
    const dispatch = useDispatch();

    function tog_center() {
        setmodal_center(!modal_center);
    }


const update_thread_titile = ()=>{
      dispatch(Update_Bot_Thread({ thread_id , title:thread_title_value , Bot_ID }))
}

  return (
    <>
     <Button style={{backgroundColor : 'transparent', padding: '0px', border: 'none'}} ><span><i className='ri-pencil-line' onClick={() => tog_center()}></i></span></Button>
    
      {/* Vertically Centered */}
      <Modal
                isOpen={modal_center}
                toggle={() => {
                    tog_center();
                }}
            >
                <ModalHeader className="modal-title" id="myModalLabel" toggle={() => { tog_center(); }}>
                    Edit Thread Name
                </ModalHeader>
                <ModalBody className="">
                        <div className='sql-inner-wrap mb-3'>
                            <Input value={thread_title_value} onChange={(e)=>[
                                setthread_title_value(e.target.value)
                            ]} type="text" className="form-control" id="edit_thread_name" />                             
                        </div>
                        <div className="hstack gap-2 justify-content-end">                            
                            <Button color="light" onClick={() => setmodal_center(false)}>Cancel</Button>
                            <Button color="secondary" onClick={() => {
                                update_thread_titile()
                                setmodal_center(false)
                                
                                }}>Save</Button>                            
                        </div>
                </ModalBody>
            </Modal>
    </>
  )
}

export default Edit_Thread_Name_Modal